import "../styles/setting.css";
import { Form, ToggleButton, ToggleButtonGroup } from "react-bootstrap";
import { updateLocalStorage } from "../helpers/updateLocalStorage";
import NotificationHeader from "../components/NotificationHeader/NotificationHeader";
import React, { useState } from "react";
import toast from "react-hot-toast";
import axiosInstance from "../api/axiosInstance";

const Setting = () => {
  const { user } = JSON.parse(localStorage.getItem("auth"));

  const [loading, setLoading] = useState(false);
  const [settings, setSettings] = useState({
    discordWebhook: user?.settings?.discordWebhook || "",
    refreshTimeout: user?.settings?.refreshTimeout || "",
    smsToEmail: user?.settings?.smsToEmail || false,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    setSettings({
      ...settings,
      [name]: value,
    });
  };

  const handleToggle = (val) => {
    setSettings((prevSettings) => ({
      ...prevSettings,
      smsToEmail: !prevSettings.smsToEmail, // Toggle True/False
    }));
  };

  console.log(settings, "settingsss");

  const handleSubmit = async (e) => {
    console.log("inside");
    e.preventDefault();

    setLoading(true);

    try {
      const response = await axiosInstance.put("user/updateUserSettings", {
        settings,
      });

      if (response.status !== 200) {
        toast.error("Unable to update settings!");
        return;
      }
      if (response?.data) {
        toast.success(response?.data?.message);
        updateLocalStorage(response?.data?.data);
      }
    } catch (error) {
      console.error("🚀 -> handleSubmit -> error:", error);
      toast.error("Unable to update settings!");
    } finally {
      setLoading(false);
    }
  };

  const handleApiDocsClick = () => {
    window.open("https://mubasharrasheed.github.io/sms2u-api-doc/", "_blank");
  };

  return (
    <>
      <NotificationHeader name="Settings" />
      <div className="SettingPage">
        <div className="container">
          <div className="pageStyle">
            <div className="row">
              <div className="col-lg-4 offset-lg-4 col-md-6 offset-md-3 col-12">
                <div className="PageBox">
                  <Form className="pb-5" onSubmit={handleSubmit}>
                    <Form.Group className="mb-5 settingToggle text-center">
                      <Form.Label className="d-block">
                        Enable SMS Email
                      </Form.Label>
                      <ToggleButtonGroup
                        type="checkbox"
                        value={settings.smsToEmail ? "ON" : "OFF"}
                        onChange={handleToggle}
                      >
                        <ToggleButton id="tbg-btn-1" value="ON">
                          ON
                        </ToggleButton>
                        <ToggleButton id="tbg-btn-2" value="OFF">
                          OFF
                        </ToggleButton>
                      </ToggleButtonGroup>
                    </Form.Group>
                    <Form.Group className="mb-5 text-center">
                      <Form.Label>Discord Webhook</Form.Label>
                      <Form.Control
                        name="discordWebhook"
                        onChange={handleChange}
                        placeholder=""
                        type="text"
                        value={settings.discordWebhook}
                      />
                    </Form.Group>
                    <Form.Group className="mb-5 text-center ">
                      <Form.Label>Refresh Timeout (Mins)</Form.Label>
                      <Form.Control
                        name="refreshTimeout"
                        onChange={handleChange}
                        placeholder=""
                        type="number"
                        value={settings.refreshTimeout}
                      />
                    </Form.Group>
                    <div className="text-center mb-5">
                      <button
                        disabled={
                          loading ||
                          (settings.discordWebhook ===
                            user?.settings?.discordWebhook &&
                            settings.refreshTimeout ===
                              user?.settings?.refreshTimeout &&
                            settings.smsToEmail === user?.settings?.smsToEmail)
                        }
                        className="primaryBtn"
                        type="submit"
                      >
                        Save Changes
                      </button>
                    </div>
                  </Form>
                  <Form>
                    <Form.Group className="mb-5 text-center ">
                      <Form.Label>Your Secret Key</Form.Label>
                      <Form.Control
                        disabled={true}
                        placeholder=""
                        type="text"
                        value={user.secretKey}
                      />
                    </Form.Group>
                    <div className="text-center mb-5">
                      <button
                        className="primaryBtn"
                        type="button"
                        onClick={handleApiDocsClick}
                      >
                        View API Docs
                      </button>
                    </div>
                  </Form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Setting;
